<script>
import axios from "axios";
import Swal from "sweetalert2";
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import {
  authFackMethods
} from "@/state/helpers";

import {
  required,
} from "vuelidate/lib/validators";

export default {
  page: {
    title: "Locations",
    meta: [
      {
        name: "Locations",
      },
    ],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      locations: {},
      preservePage: 1,
      pageLimit: 50,
      modalTitle: '',
      locationId: '',
      buildingIds: [],
      status: [{ value: 'private', text: 'Private' }, { value: 'public', text: 'Public' }],
      roleTypes: [{ value: 0, text: 'Any' }, { value: 3, text: 'Mentor' }, { value: 4, text: 'Volunteer' }],
      addbuildingform: {
        name: "",
        location_id: "",
        description: ""
      },
      locationsList: [],
      locationForm: {
        name: "",
        description: "",
        status: "",
        user_type_id: "",
        sort_order: 0,
      },
      searchForm: {
        name: null,
        status: null,
      },
      typesubmit: false,
      isUpdate: false,
      isAdd: false,
      isName: false,
      isStatus: false,
      isSearching: false,
      searchBy: '',
      isLoading: false,
      noRecord: false,
    }
  },
  validations: {
    addbuildingform: {
      name: { required },
      location_id: { required },
      description: { required }
    },
    locationForm: {
      name: { required },
      description: { required },
      status: { required },
      user_type_id: { required },
      sort_order: { required },
    },
  },
  mounted() {
    this.getLocations();
  },
  methods: {
    getLocations(page) {
      this.isLoading = true;
      this.noRecord = false;
      if (typeof page === 'undefined') {
        page = 1
      }
      this.preservePage = page;
      let filter = '&per_page=' + this.pageLimit
      if (this.searchForm.name) {
        filter += '&name=' + this.searchForm.name
      }
      if (this.searchForm.status) {
        filter += '&status=' + this.searchForm.status
      }
      axios.get('locations?pagination=true&page=' + page + filter).then(res => {
        this.locations = res.data.response;
        this.isLoading = false;
        if (!this.locations.data.length) {
          this.noRecord = true;
          if (page > 1) {
            this.getLocations(page - 1);
          }
        }
      }).catch((err) => {
        if (err.response) {
          if (err.response.status == 401) {
            this.logout();
          }
        }
      })
    },
    ...authFackMethods,

    deleteRecord() {
      this.getLocations(this.preservePage);
    },

    getAllLocations() {
      axios.get('locations?pagination=true&per_page=1000').then(res => {
        this.locationsList = res.data.response.data;
      })
    },

    editLocation(location) {
      this.isUpdate = true;
      this.isAdd = false;
      this.modalTitle = 'Edit Location';
      this.$bvModal.show('locationModal');
      this.locationForm.name = location.name;
      this.locationForm.description = location.description;
      this.locationForm.status = location.status;
      this.locationForm.user_type_id = location.user_type_id;
      this.locationForm.sort_order = location.sort_order || 0;
      this.locationId = location.id;
      let selectedBuildings = [];
      location.buildings.map(function (value) {
        selectedBuildings.push(value);
      });
      this.buildingIds = selectedBuildings
    },

    deleteLocation(location) {
      this.locationId = location.id;
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        showLoaderOnConfirm: true,
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.isConfirmed) {
          var token = localStorage.getItem('token');
          var config = {
            headers: {
              Authorization: 'Bearer ' + token,
              'Accept': 'application/json'
            }
          };
          if (token) {
            axios.delete('admin/locations/' + this.locationId, config)
              .then((res) => {
                if (res.status == '200') {
                  Swal.fire({
                    title: "Deleted!",
                    text: location.name + " has been deleted!",
                    icon: "success",
                    width: 350,
                    showConfirmButton: false,
                    timer: 1500
                  });
                  this.getLocations(this.preservePage);
                }
              })
              .catch((err) => {
                if (err.response) {
                  Swal.fire({
                    title: "Error!",
                    text: err.response.data.error.message,
                    icon: "danger",
                    width: 350,
                    showConfirmButton: true
                  });
                }
              })
          }
        }
      });
    },

    addLocation() {
      this.modalTitle = 'Add Location'
      this.$bvModal.show('locationModal');
      this.isAdd = true;
      this.isUpdate = false;
      this.emptyLocationFields();
    },

    showBuildingModal() {
      this.getAllLocations();
      this.$bvModal.show('buildingModal');
      this.emptyBuildingFields();
    },

    emptyBuildingFields() {
      this.addbuildingform = {
        name: "",
        location_id: "",
        description: ""
      }
    },

    emptyLocationFields() {
      this.locationForm = {
        name: "",
        description: "",
        status: "",
        user_type_id: "",
        sort_order: "",
      }
    },

    saveBuilding() {
      this.typesubmit = true;
      // stop here if form is invalid
      this.$v.addbuildingform.$touch();
      if (!this.$v.addbuildingform.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.post('admin/buildings', this.addbuildingform, config)
            .then((res) => {
              if (res.status == 200) {
                Swal.fire({
                  title: "Success!",
                  text: "Building added successfully!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500
                });
                this.getLocations();
                this.$bvModal.hide('buildingModal');
                this.typesubmit = false;
              }
            })
            .catch((err) => {
              if (err.response) {
                Swal.fire({
                  title: "Error!",
                  text: err.response.data.error.message,
                  icon: "danger",
                  width: 350,
                  showConfirmButton: true
                });
              }
            })
        }
      }
    },

    removeBuilding(building) {
      delete this.buildingIds[building]
      this.buildingIds.splice(building, 1)
    },

    saveLocation() {
      this.typesubmit = true;
      this.$v.$touch();
      if (!this.$v.locationForm.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.post('admin/locations', this.locationForm, config)
            .then((res) => {
              if (res.status == '200') {
                Swal.fire({
                  title: "Success!",
                  text: "Location added successfully!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500
                });
                // this.getAllLocations();
                this.getLocations();
                this.addLocation();
                this.$bvModal.hide('locationModal');
                this.typesubmit = false;
              }
            })
            .catch((err) => {
              if (err.response) {
                Swal.fire({
                  title: "Error!",
                  text: err.response.data.error.message,
                  icon: "danger",
                  width: 350,
                  showConfirmButton: true
                });
              }
            })
        }
      }
    },

    updateLocation() {
      this.typesubmit = true;
      let currentBuildings = [];
      this.buildingIds.map(function (value) {
        currentBuildings.push(value.id);
      });
      this.locationForm.building_ids = currentBuildings;
      this.$v.$touch();
      console.log(this.$v.$touch());
      if (!this.$v.locationForm.$invalid) {
        var token = localStorage.getItem('token');
        var config = {
          headers: {
            Authorization: 'Bearer ' + token,
            'Accept': 'application/json'
          }
        };
        if (token) {
          axios.patch('admin/locations/' + this.locationId, this.locationForm, config)
            .then((res) => {
              if (res.status == '200') {
                Swal.fire({
                  title: "Success!",
                  text: "Location updated successfully!",
                  icon: "success",
                  width: 350,
                  showConfirmButton: false,
                  timer: 1500
                });
                this.getLocations();
                this.$bvModal.hide('locationModal');
                this.typesubmit = false;
              }
            })
            .catch((err) => {
              if (err.response) {
                Swal.fire({
                  title: "Error!",
                  text: err.response.data.error.message,
                  icon: "danger",
                  width: 350,
                  showConfirmButton: true
                });
              }
            })
        }
      }
    },

    searchOption(event) {
      this.searchForm = {
        name: null,
        status: null,
      };
      let selectedValue = event.target.value
      if (selectedValue == '') {
        this.resetSearch();
      }
      if (selectedValue == 'name') {
        this.getAllLocations();
        this.isName = true;
        this.isStatus = false;
        this.isSearching = true;
      }
      if (selectedValue == 'status') {
        this.isName = false;
        this.isStatus = true;
        this.isSearching = true;
      }
    },

    searchLocation() {
      this.getLocations();
    },

    resetSearch() {
      this.searchForm = {
        name: null,
        status: null,
      };
      this.isSearching = false;
      this.isName = false;
      this.isStatus = false;
      this.searchBy = '';
      this.getLocations();
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-body">

        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Locations</h5>
          </div>

          <div class="mb-4 mdl-btns ms-auto">

            <!--Location Modal-->
            <b-button id="show-btn" @click="addLocation" variant="primary" title="Add Location">
              Add Location
            </b-button>

            <!--Building Modal-->
            <b-button @click="showBuildingModal" variant="primary">Add Building</b-button>
            <b-modal
                id="buildingModal"
                centered
                title="Add Building"
                title-class="font-18"
                hide-footer
            >
              <form>
                <div class="mb-3">
                  <label>Building Name</label>
                  <input
                      v-model="addbuildingform.name"
                      type="text"
                      class="form-control"
                      placeholder="Enter Location Name"
                      name="name"
                      :class="{
                        'is-invalid': typesubmit && $v.addbuildingform.name.$error,
                      }"
                  />
                  <div
                      v-if="typesubmit && $v.addbuildingform.name.$error"
                      class="invalid-feedback"
                  >
                  <span v-if="!$v.addbuildingform.name.required"
                  >Building name is required.</span
                  >
                  </div>
                </div>

                <div class="mb-3">

                  <label class="mt-0">Select Location</label>

                  <b-form-select class="form-select" v-model="addbuildingform.location_id" :options="locationsList"
                                 value-field="id"
                                 text-field="name"
                                 :class="{ 'is-invalid': typesubmit && $v.addbuildingform.location_id.$error, }"
                  >
                    <option slot="first" :value="null" disabled>Select Location</option>
                  </b-form-select>
                  <div
                      v-if="typesubmit && $v.addbuildingform.location_id.$error"
                      class="invalid-feedback"
                  >
                  <span v-if="!$v.addbuildingform.location_id.required"
                  >Location is required.</span>
                  </div>

                </div>

                <div class="mb-3">
                  <label>Description</label>
                  <div>
                  <textarea
                      v-model="addbuildingform.description"
                      class="form-control"
                      name="description"
                      :class="{
                        'is-invalid': typesubmit && $v.addbuildingform.description.$error,
                      }"
                      rows="5" placeholder="Enter Description"
                  ></textarea>
                    <div
                        v-if="typesubmit && $v.addbuildingform.description.$error"
                        class="invalid-feedback"
                    >
                    <span v-if="!$v.addbuildingform.description.required"
                    >Description is required.</span
                    >
                    </div>
                  </div>
                </div>

                <div class="mb-3 mb-0">
                  <div>
                    <button type="button" @click="saveBuilding" class="btn btn-primary">Submit</button>
                  </div>
                </div>
              </form>

            </b-modal>

          </div>

        </div>

        <form class="row align-items-center form-inline mb-4 border p-3 m-0">
          <div class="col-md-12">
            <h4 class="font-size-14">Search By:</h4>
          </div>
          <div class="col-md-4">
            <select
                class="form-select custom-select" v-model="searchBy" @change="searchOption($event)">
              <option value="">Select Option</option>
              <option value="name">Location Name</option>
              <option value="status">Status</option>
            </select>
          </div>
          <div class="col-md-2 sm-hidden xs-hidden"></div>
          <div class="col-md-6 pull-right">
            <div class="row app-search pt-0 pb-0">

              <div class="col-md-12 d-flex">
                <input v-if="isName"
                    v-model="searchForm.name"
                    type="text"
                    class="ps-4 form-control"
                    placeholder="Type Location"
                />
                <b-form-select v-if="isStatus" class="form-select" v-model="searchForm.status" :options="status">
                  <option slot="first" :value="null" disabled>Select Status</option>
                </b-form-select>

                <b-button v-if="isSearching" class="btn-find" id="show-btn" @click="searchLocation"
                          variant="primary" title="Search">
                  <i class="bx bx-search-alt-2"> Search</i>
                </b-button>

                <b-button v-if="isSearching" class="btn-reset ms-2" id="show-btn" @click="resetSearch"
                          variant="primary" title="Reset">
                  <i class="bx bx-reset"> Reset</i>
                </b-button>
              </div>
              <div class="col-md-10">
              </div>
              <div class="col-md-2">
              </div>
            </div>
          </div>
        </form>


        <div class="table-responsive ">
          <table class="table table-bordered table-hover table-striped table-sm align-middle table-nowrap mb-0">

            <thead class="table-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Status</th>
              <th scope="col">Description</th>
              <th scope="col">Buildings</th>
              <th scope="col">Actions</th>
            </tr>
            </thead>
            <tbody>

            <tr v-if="noRecord">
              <td colspan="5" class="p-0">
                <p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
              </td>
            </tr>
            <tr v-if="isLoading">
              <td colspan="5" class="text-center p-0">
                <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                ></b-spinner>
              </td>
            </tr>

            <tr v-else v-for="(location, index) in locations.data" :key="index">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  {{ location.name }}
                </h5>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1 text-capitalize">
                  {{ location.status }}
                </h5>
              </td>
              <td>
                <p class="text-muted mb-0 text-wrap">
                  {{ location.description.substr(0, 50) + '...' }}
                </p>
              </td>
              <td>
                <p class="text-muted mb-0 text-wrap" v-for="(building, building_id) in location.buildings" :key="building_id">
                  <span>{{ building.name }}</span>
                </p>
              </td>
              <td class="text-center">
                <b-button id="show-btn" @click="editLocation(location)" variant="primary" title="Edit">
                  <i class="bx bx-pencil"></i>
                </b-button>
                <b-button @click="deleteLocation(location)" class="ms-2" variant="danger" title="Delete">
                  <i class="bx bx-trash"></i>
                </b-button>
              </td>

            </tr>

            </tbody>
          </table>
        </div>

        <pagination class="mt-4" :data="locations" :limit="10" @pagination-change-page="getLocations"></pagination>

      </div>
    </div>

    <b-modal
        id="locationModal"
        centered
        :title="modalTitle"
        title-class="font-18"
        hide-footer
    >
      <form>
        <div class="mb-3">
          <label>Location Name</label>
          <input
              v-model="locationForm.name"
              type="text"
              class="form-control"
              placeholder="Enter Location Name"
              name="name"
              :class="{
                'is-invalid': typesubmit && $v.locationForm.name.$error,
              }"
          />
          <div
              v-if="typesubmit && $v.locationForm.name.$error"
              class="invalid-feedback"
          >
                  <span v-if="!$v.locationForm.name.required"
                  >Location name is required.</span
                  >
          </div>
        </div>

        <div class="mb-3">
          <label>Description</label>
          <div>
                  <textarea
                      v-model="locationForm.description"
                      class="form-control"
                      name="description"
                      :class="{
                        'is-invalid': typesubmit && $v.locationForm.description.$error,
                      }"
                      rows="5" placeholder="Enter Description"
                  ></textarea>
            <div
                v-if="typesubmit && $v.locationForm.description.$error"
                class="invalid-feedback"
            >
                    <span v-if="!$v.locationForm.description.required"
                    >Description is required.</span
                    >
            </div>
          </div>
        </div>

        <div class="mb-3">

          <label class="mt-0">Select Status</label>
          <b-form-select class="form-select" v-model="locationForm.status" :options="status"
                         :class="{ 'is-invalid': typesubmit && $v.locationForm.status.$error, }"
          >
            <option slot="first" :value="null" disabled>Select Location</option>
          </b-form-select>
          <div
              v-if="typesubmit && $v.locationForm.status.$error"
              class="invalid-feedback"
          >
                  <span v-if="!$v.locationForm.status.required"
                  >Status is required.</span>
          </div>

        </div>

        <div class="mb-3">

          <label class="mt-0">Select Role Type</label>
          <b-form-select class="form-select" v-model="locationForm.user_type_id" :options="roleTypes"
                         :class="{ 'is-invalid': typesubmit && $v.locationForm.user_type_id.$error, }"
          >
            <option slot="first" :value="null" disabled>Select Role Type</option>
          </b-form-select>
          <div
              v-if="typesubmit && $v.locationForm.user_type_id.$error"
              class="invalid-feedback"
          >
                  <span v-if="!$v.locationForm.user_type_id.required"
                  >Role Type is required.</span>
          </div>

        </div>

        <div class="mb-3">

          <label>Location Order</label>
          <input
              v-model="locationForm.sort_order"
              type="number"
              min="0"
              step="1"
              class="form-control"
              placeholder="Location Order"
              name="sort_order"
              :class="{
                'is-invalid': typesubmit && $v.locationForm.sort_order.$error,
              }"
          />

        </div>

        <div class="mb-3" v-if="isUpdate">

          <label class="mt-0">Click to Remove Building</label>
          <b-list-group class="building-list">
            <b-list-group-item
                v-model="buildingIds" v-for="(building, buildingId) in buildingIds" :key="buildingId">
              <span class="inline-block mr-1">{{ building.name }}</span>
              <span class="remove-icon" v-on:click="removeBuilding(buildingId)">
                <i class="bx bx-x"></i></span>
            </b-list-group-item>
          </b-list-group>

        </div>
        <div class="mb-0">
          <div>
            <button type="button" v-if="isAdd" @click="saveLocation" class="btn btn-primary">Add Location</button>
            <button type="button" v-if="isUpdate" @click="updateLocation" class="btn btn-primary">Update Location</button>
          </div>
          <div>
          </div>
        </div>
      </form>
    </b-modal>

  </Layout>
</template>
<style scoped>
.mdl-btns button:nth-child(1) {
  margin-right: 1rem;
}

.building-list {
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  gap: 10px;
}

.building-list .list-group-item {
  padding: .5rem .5rem;
  display: flex !important;
  justify-content: space-between;
  border: 1px solid #c8cbcd;
  border-radius: .4rem;
  font-size: 12px;
}

.remove-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #212529;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 18px;
  cursor: pointer;
  margin-left: 5px;
}

.app-search input,
.app-search select {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.app-search .btn-find {
  width: 40%;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  box-shadow: none;
}

.app-search .btn-reset {
  width: 40%;
  font-size: 15px;
  box-shadow: none;
  border-radius: 30px;
}
</style>
